import { vetSpecialtiesTagEnum } from "beitary-shared";
import { BMultiSelect } from "components";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export interface TagsMultiselectProps {
  required?: boolean;
  onChange?: (value: string[] | undefined) => void;
  error?: ReactNode;
  value?: string[]; // could be undefined if form has no initial values
  disabled?: boolean;
}

export const TagsMultiselect = (props: TagsMultiselectProps) => {
  const { t } = useTranslation();
  const data = vetSpecialtiesTagEnum.options.map((o) => ({
    value: o,
    label: t(o),
  }));

  return (
    <BMultiSelect
      {...props}
      maxSelectedValues={10}
      label={t("TAGS")}
      nothingFound={t("NOTHING_FOUND")}
      description={t("MAXIMUM_OF_10")}
      data={data}
    />
  );
};
